module.exports = __webpack_public_path__ + "img/kaka.6c0be7b6.svg";